import Vue from 'vue'
import {HTTP} from '@/utils/httpCommonUtil'
import {getRestParamErrorMessage, getRestResponseErrorMessage} from '@/utils/serverErrorMessageUtil';
import {Money} from 'v-money';
import DataLoadCard from '@/componentsReusable/DataLoadCard.vue';
import ExpandableRowItems from "@/componentsReusable/ExpandableRowItems.vue";
import RowItemSummary from "@/componentsReusable/RowItemSummary.vue";
import CrudList from "@/componentsReusable/CrudList.vue";

export interface RepresentativeGoal {
  id: number;
  nmrEmployeeId: number;
  year: number;
  yearErrorMessage: string;
  amount: string;
  amountErrorMessage: string;
  note: string;
  noteErrorMessage: string;
  isEditing: boolean;
  isUpdating: boolean;
  isNew: boolean;
}

export default Vue.component('representative-goal-card', {
  name: 'RepresentativeGoalCard',
  data () {
    let color: any;
    return {
      savingNewGoal: false,
      msg: 'RepresentativeGoalCard',
      cardExpanded: false,
      color: color,
      loadingUserData: false,
      userDataErrorMessage: '',
      userData: [],
      loadingGoalData: false,
      representativeGoalErrorMessage: '',
      money: {
        decimal: '.',
        thousands: ',',
        prefix: '$',
        precision: 2
      }
    }
  },
  components: {
    DataLoadCard,
    ExpandableRowItems,
    RowItemSummary,
    CrudList,
    Money
  },
  computed: {
    loadingData(): boolean {
      return this.loadingUserData || this.loadingGoalData;
    }
  },

  methods: {

    cleanupOtherCards: function () {
      this.userData.forEach((user: any) => {
        let indexesToDelete: any = [];
        user.representativeGoals.forEach((goal: RepresentativeGoal, index: number) => {
          if (goal.isNew) {
            indexesToDelete.push(index);
          }
          goal.isEditing = false;
        });
        indexesToDelete.forEach(function (indx: number) {
          user.representativeGoals.splice(indx, 1);
        });
      });
    },
    toggleEditGoal(goal: any) {
      if (!goal.isEditing) {
        this.cleanupOtherCards();
      }
      goal.isEditing = !goal.isEditing;
    },
    async loadData() {
      await this.getUsers();
      await this.getRepresentativeGoals();
    },
    async getUsers() {
      this.loadingUserData = true;
      try {

        const response = await HTTP.get('/api/providers/owner-candidates');
        response.data.data.forEach((record: any) => {
          record.expanded = false;
          record.representativeGoals = [];
        });
        this.userData = response.data.data;
        this.loadingUserData = false;
      } catch (error) {
        console.log('response Error!');
        this.loadingUserData = false;
        this.userDataErrorMessage = error;
        this.$notify({
          group: 'main',
          type: 'error',
          title: 'Error',
          text: 'An error occurred getting user data.',
          duration: 5000
        });
      }
    },
    async getRepresentativeGoals() {
      this.loadingGoalData = true;
      try {
        const response = await HTTP.get('/api/representative-goals/');
        const representativeGoalData = response.data.data;
        representativeGoalData.forEach((record: any) => {
          record.isEditing = false;
          record.isUpdating = false;
          record.isNew = false;
          record.yearErrorMessage = '';
          record.amountErrorMessage = '';
          record.noteErrorMessage = '';
        });
        this.userData.forEach((user: any) => {
          Vue.set(user, 'representativeGoals', []);
          user.representativeGoals.push(... representativeGoalData.filter((repGoal: RepresentativeGoal) => {
            return repGoal.nmrEmployeeId === user.id;
          }))
        });

        this.loadingGoalData = false;
      } catch (error) {
        console.log('response Error!');
        this.loadingGoalData = false;
        this.representativeGoalErrorMessage = error;
        this.$notify({
          group: 'main',
          type: 'error',
          title: 'Error',
          text: 'An error occurred getting the NMR Employee goals.',
          duration: 5000
        });
      }
    },
    addRepresentativeGoal(user: any) {
      this.cleanupOtherCards();
      user.representativeGoals.push({
        id: +('-' + new Date().getTime()),
        nmrEmployeeId: user.id,
        year: 0,
        yearErrorMessage: '',
        amount: '',
        amountErrorMessage: '',
        note: '',
        noteErrorMessage: '',
        isEditing: true,
        isUpdating: false,
        isNew: true
      });
    },
    canAddGoal(user: any) {
      return user.representativeGoals.every((goal: RepresentativeGoal) => {
        return !goal.isNew;
      });
    },
    async cancelRepresentativeGoalChanges(representativeGoal: RepresentativeGoal) {
      await this.getRepresentativeGoals();
    },
    async writeRepresentativeGoal(representativeGoal: RepresentativeGoal) {
      representativeGoal.isUpdating = true;
      try {
        representativeGoal.id < 0
          ? await HTTP.post('/api/representative-goals/', representativeGoal)
          : await HTTP.put(`/api/representative-goals/${representativeGoal.id}`,representativeGoal);
        await this.getRepresentativeGoals();
      } catch (error) {
        this.representativeGoalErrorMessage = error;
        representativeGoal.isUpdating = false;
        representativeGoal.yearErrorMessage = getRestParamErrorMessage(error, 'year');
        representativeGoal.amountErrorMessage = getRestParamErrorMessage(error, 'amount');
        representativeGoal.noteErrorMessage = getRestParamErrorMessage(error, 'note');
        if (
          !representativeGoal.yearErrorMessage.length &&
          !representativeGoal.amountErrorMessage.length &&
          !representativeGoal.noteErrorMessage.length
        ) {
          let generalError = getRestResponseErrorMessage(error);
          this.$notify({
            group: 'main',
            type: 'error',
            title: 'Error Updating',
            text: generalError ? generalError : "An error occurred saving the NMR employee goal.",
            // duration: 5000
          });
        }

      }
    },
    async deleteRepresentativeGoal(representativeGoal: RepresentativeGoal) {
      try {
        await HTTP.delete(`/api/representative-goals/${representativeGoal.id}`);
        await this.getRepresentativeGoals();
      } catch(error) {
        console.log('response Error!');
        this.representativeGoalErrorMessage = error;
        this.$notify({
          group: 'main',
          type: 'error',
          title: 'Error',
          text: "An error occurred deleting the NMR employee goal.",
          duration: 5000
        });
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/components/settings/cards/nmremployee/RepresentativeGoalCard.ts